var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dialog_visible" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "改价",
            visible: _vm.editChangePriceDialogVisible,
            width: "750px"
          },
          on: {
            "update:visible": function($event) {
              _vm.editChangePriceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              staticClass: "mar20-b",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.changeGoodsList }
            },
            [
              _c("el-table-column", {
                attrs: { width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "flex mar15-b" }, [
                          _c(
                            "div",
                            {
                              staticClass: "overflow flex-shrink mar12-r wh72"
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    scope.row.goodsPic +
                                    "?imageView2/1/w/72/h/72"
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "goodsName", label: "商品名称", width: "180" }
              }),
              _c("el-table-column", {
                attrs: { prop: "goodsSpec", label: "规格", width: "100" }
              }),
              _c("el-table-column", {
                attrs: { label: "价格", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: "用户填写金额",
                            type: "text",
                            autocomplete: "off"
                          },
                          on: {
                            input: function($event) {
                              scope.row.sellFactPrice = _vm.formatNum6(
                                scope.row.sellFactPrice,
                                true
                              )
                            },
                            change: _vm.editChangePrice
                          },
                          model: {
                            value: scope.row.sellFactPrice,
                            callback: function($$v) {
                              _vm.$set(
                                scope.row,
                                "sellFactPrice",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.sellFactPrice"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "数量", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: "用户填写数量",
                            type: "text",
                            autocomplete: "off"
                          },
                          on: {
                            input: function($event) {
                              scope.row.goodsQuantity = _vm.formatNums(
                                scope.row.goodsQuantity,
                                true
                              )
                            },
                            change: _vm.editChangePrice
                          },
                          model: {
                            value: scope.row.goodsQuantity,
                            callback: function($$v) {
                              _vm.$set(
                                scope.row,
                                "goodsQuantity",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.goodsQuantity"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "运费" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: "用户填写运费金额",
                            type: "text",
                            autocomplete: "off",
                            disabled: _vm.isSignMaterialStatement == 1
                          },
                          on: {
                            input: function($event) {
                              scope.row.freightMoneyTotal = _vm.formatNums(
                                scope.row.freightMoneyTotal,
                                true
                              )
                            },
                            change: _vm.editChangePrice
                          },
                          model: {
                            value: scope.row.freightMoneyTotal,
                            callback: function($$v) {
                              _vm.$set(
                                scope.row,
                                "freightMoneyTotal",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.freightMoneyTotal"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.isSubtractMoney == 1 && _vm.isSignMaterialStatement != 1
            ? _c(
                "el-form",
                {
                  attrs: {
                    "label-suffix": "：",
                    "label-position": "left",
                    size: "medium"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("span", { staticClass: "w110 mar5_r" }, [
                        _vm._v(" 抹零金额")
                      ]),
                      _c("el-input", {
                        staticClass: "mar10-r w100",
                        attrs: {
                          placeholder: "用户填写金额",
                          type: "text",
                          autocomplete: "off",
                          disabled:
                            _vm.subtractMoney > 0 &&
                            _vm.isSignMaterialStatement != 1
                        },
                        on: {
                          input: function($event) {
                            _vm.subtractMoney = _vm.formatNums(
                              _vm.subtractMoney,
                              true
                            )
                          },
                          change: _vm.editChangePrice
                        },
                        model: {
                          value: _vm.subtractMoney,
                          callback: function($$v) {
                            _vm.subtractMoney =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "subtractMoney"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "text-right pad10-b f15 fb" }, [
            _c("span", [_vm._v("总金额： ")]),
            _c("span", [_vm._v("¥ ")]),
            _c("span", [_vm._v(" " + _vm._s(_vm.finalChangeMoney) + " ")])
          ]),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function($event) {
                      _vm.editChangePriceDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.toChangePriceSubmit()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "confirm-pick seller-style",
          attrs: {
            size: "50%",
            direction: "rtl",
            visible: _vm.editConfirmSelfPickupDialogVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.editConfirmSelfPickupDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "fb gray3 f18",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("确认自提")]
          ),
          _c("div", { staticClass: "h100-full flex flex-column" }, [
            _vm.confirmSelfPickupButton.isSellerVoucher == 1
              ? _c(
                  "div",
                  { staticClass: "flex-auto pad20 scroll-y" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "right",
                          "label-width": "120px"
                        }
                      },
                      [
                        _vm.order.orderDtlBo &&
                        _vm.order.orderDtlBo.pickupCode &&
                        _vm.order.orderDtlBo.pickupCode != ""
                          ? _c(
                              "el-form-item",
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "f15 fb",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [_vm._v("请输入提货码：")]
                                ),
                                _c("el-input", {
                                  staticClass: "mar10-r",
                                  attrs: {
                                    type: "text",
                                    oninput:
                                      "value = value.replace(/[^0-9.]/g, '')"
                                  },
                                  model: {
                                    value: _vm.thisInputPickupCode,
                                    callback: function($$v) {
                                      _vm.thisInputPickupCode =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "thisInputPickupCode"
                                  }
                                }),
                                _c("span", { staticClass: "red f12" }, [
                                  _vm._v(
                                    "提货码可向提货人索要，同时请验证司机车牌和身份"
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.order.vehicleList && _vm.order.vehicleList.length
                          ? [
                              _c(
                                "div",
                                { staticClass: "flex justify-end mar10-b" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "blue pointer mar20-l",
                                      on: {
                                        click: function($event) {
                                          _vm.importCarVisible = true
                                        }
                                      }
                                    },
                                    [_vm._v("导入自提信息")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "blue pointer mar20-l",
                                      on: {
                                        click: function($event) {
                                          _vm.addCarVisible = true
                                        }
                                      }
                                    },
                                    [_vm._v("新增自提信息")]
                                  )
                                ]
                              ),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.order.vehicleList,
                                    border: "",
                                    "header-cell-style": {
                                      backgroundColor: "#f7f7f7"
                                    },
                                    "show-summary": "",
                                    "summary-method": _vm.getSummaries
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "licensePlateNum",
                                      label: "车牌号",
                                      align: "center"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "name",
                                      label: "司机",
                                      align: "center"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "tel",
                                      label: "联系方式",
                                      align: "center"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "idCard",
                                      label: "身份证",
                                      align: "center"
                                    }
                                  }),
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: { align: "center" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var row = ref.row
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.pickupQuantity || "-"
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2885777245
                                      )
                                    },
                                    [
                                      _c("template", { slot: "header" }, [
                                        _vm._v(
                                          "提货数量(" +
                                            _vm._s(
                                              _vm.order.vehicleList[0]
                                                .pickupGoodsUnit
                                            ) +
                                            ")"
                                        )
                                      ])
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        prop: "actualSendQuantity",
                                        align: "center"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _c("el-input-number", {
                                                  staticClass: "w100-full",
                                                  attrs: {
                                                    size: "mini",
                                                    label: "请输入",
                                                    precision: 4,
                                                    min: 0,
                                                    max:
                                                      scope.row
                                                        .pickupQuantity ||
                                                      999999999,
                                                    step: 1,
                                                    placeholder: "请输入"
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.actualSendQuantityChange
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row
                                                        .actualSendQuantity,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "actualSendQuantity",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.actualSendQuantity"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1043090116
                                      )
                                    },
                                    [
                                      _c("template", { slot: "header" }, [
                                        _vm._v(
                                          "实发数量(" +
                                            _vm._s(
                                              _vm.order.vehicleList[0]
                                                .pickupGoodsUnit
                                            ) +
                                            ")"
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          : _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { data: _vm.goodsListCopy }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "goodsName",
                                    label: "商品名称"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "goodsQuantity",
                                    label: "数量",
                                    width: "100"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "sellFactPrice",
                                    label: "价格",
                                    width: "100"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "金额", width: "100" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              " ￥" +
                                                _vm._s(
                                                  (
                                                    scope.row.goodsQuantity *
                                                    scope.row.sellFactPrice
                                                  ).toFixed(2)
                                                ) +
                                                " "
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    904484387
                                  )
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "提货数量" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              staticClass: "w100-full",
                                              attrs: {
                                                size: "mini",
                                                label: "请输入",
                                                min: 0,
                                                max: scope.row.goodsQuantity,
                                                step: 1
                                              },
                                              on: {
                                                change: function(currentValue) {
                                                  return _vm.deliveryGoodsQuantityChange(
                                                    currentValue,
                                                    scope
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  scope.row
                                                    .deliveryGoodsQuantity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "deliveryGoodsQuantity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.deliveryGoodsQuantity"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    145786684
                                  )
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "remark", label: "备注" }
                                })
                              ],
                              1
                            ),
                        Number(_vm.balanceRefundTotal) &&
                        _vm.order.paymentType == "1" &&
                        _vm.order.paymentSt == 9
                          ? _c(
                              "el-alert",
                              {
                                staticClass: "mar20-t radius10",
                                attrs: {
                                  title: "请提醒客户注意查收",
                                  type: "success",
                                  closable: false
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "订单涉及商品调整，预计产生退款 ￥" +
                                      _vm._s(_vm.balanceRefundTotal)
                                  )
                                ]),
                                _c("p", [
                                  _vm._v(
                                    "退款将在订单完成后，退还至客户的" +
                                      _vm._s(
                                        _vm.order.vehicleList &&
                                          _vm.order.vehicleList.length
                                          ? "预付款"
                                          : "付款账户/预付款"
                                      ) +
                                      "账户"
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "flex flex-column item mar20-tb" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center mar15-b" },
                              [
                                _c("div", { staticClass: "f15 fb" }, [
                                  _vm._v(
                                    "卖家上传凭证（仅支持图片和ZIP压缩包，最多5张）"
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "flex flex-wrap upload" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-center items-center relative pointer box"
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          limit: 5 - _vm.photoList.length,
                                          action:
                                            _vm.env.VUE_APP_fileserver +
                                            "persistentUpload",
                                          "file-list": _vm.photoList,
                                          "list-type": "picture-card",
                                          "on-success": _vm.uploadSuccess,
                                          "before-upload": _vm.uploadBefore,
                                          "on-remove": _vm.uploadRemove,
                                          "on-exceed": _vm.uploadExceed
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "radius100",
                                          attrs: {
                                            src: require("./images/add.png")
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _c("div", { staticClass: "mar10-b" }, [
                          _vm._v("温馨提示：")
                        ]),
                        _c("div", { staticClass: "mar10-b" }, [
                          _vm._v(
                            "为避免交易风险，确认提货前请上传提货单等交货凭证。"
                          )
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            点击“确认自提”，即视为您按照买家实际下单的具体信息（包括但不限于货品的品类、数量、质量标准、自提车辆信息等）交付，请勿将货品转让给其他人，\n            且不得进行套现等不正当的行为。请您务必确保操作准确无误!否则，由此产生的风险和责任将由您自行承担。\n          "
                          )
                        ])
                      ],
                      2
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "flex-auto pad20 scroll-y" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "right",
                          "label-width": "100px"
                        }
                      },
                      [
                        _vm.order.orderDtlBo &&
                        _vm.order.orderDtlBo.pickupCode &&
                        _vm.order.orderDtlBo.pickupCode != ""
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "请输入提货码" } },
                              [
                                _c("el-input", {
                                  staticClass: "mar10-r",
                                  attrs: {
                                    type: "text",
                                    oninput:
                                      "value = value.replace(/[^0-9.]/g, '')"
                                  },
                                  model: {
                                    value: _vm.thisInputPickupCode,
                                    callback: function($$v) {
                                      _vm.thisInputPickupCode =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "thisInputPickupCode"
                                  }
                                }),
                                _c("span", { staticClass: "red f12" }, [
                                  _vm._v(
                                    "提货码可向提货人索要，同时请验证司机车牌和身份"
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "mar10-b" }, [
                          _vm._v("温馨提示：")
                        ]),
                        _c("div", { staticClass: "mar10-b" }, [
                          _vm._v(
                            "为避免交易风险，确认提货前请上传提货单等交货凭证。"
                          )
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            点击“确认自提”，即视为您按照买家实际下单的具体信息（包括但不限于货品的品类、数量、质量标准、自提车辆信息等）交付，请勿将货品转让给其他人，\n            且不得进行套现等不正当的行为。请您务必确保操作准确无误!否则，由此产生的风险和责任将由您自行承担。\n          "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
            _vm.order.orderDtlBo &&
            _vm.order.orderDtlBo.pickupCode &&
            _vm.order.orderDtlBo.pickupCode == ""
              ? _c(
                  "div",
                  { staticClass: "text-right pad20 flex-shrink" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "medium" },
                        on: {
                          click: function($event) {
                            _vm.editConfirmSelfPickupDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "medium", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toConfirmSelfPickupSubmit()
                          }
                        }
                      },
                      [_vm._v("确认自提")]
                    )
                  ],
                  1
                )
              : _c("div", { staticClass: "flex-shrink pad20" }, [
                  _vm.orderSellerCredential.credentialAuditStatus
                    ? _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _vm.orderSellerCredential.credentialAuditStatus == 2
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.editConfirmSelfPickupDialogVisible = false
                                    }
                                  }
                                },
                                [_vm._v("取 消")]
                              )
                            : _vm._e(),
                          _vm.orderSellerCredential.credentialAuditStatus == 2
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toConfirmSelfPickupSubmit()
                                    }
                                  }
                                },
                                [_vm._v("确 定")]
                              )
                            : _vm._e(),
                          _vm.orderSellerCredential.credentialAuditStatus ==
                            0 &&
                          _vm.orderSellerCredential.sellerVoucherImgUrl &&
                          _vm.orderSellerCredential.sellerVoucherImgUrl.length >
                            0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.editConfirmSelfPickupDialogVisible = false
                                    }
                                  }
                                },
                                [_vm._v("审核中...")]
                              )
                            : _vm._e(),
                          _vm.orderSellerCredential.credentialAuditStatus ==
                            0 && !_vm.orderSellerCredential.sellerVoucherImgUrl
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.editConfirmSelfPickupDialogVisible = false
                                    }
                                  }
                                },
                                [_vm._v("取 消")]
                              )
                            : _vm._e(),
                          _vm.orderSellerCredential.credentialAuditStatus ==
                            0 && !_vm.orderSellerCredential.sellerVoucherImgUrl
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.confirm }
                                },
                                [_vm._v("确 定")]
                              )
                            : _vm._e(),
                          _vm.orderSellerCredential.credentialAuditStatus == 1
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.editConfirmSelfPickupDialogVisible = false
                                    }
                                  }
                                },
                                [_vm._v("关 闭")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "medium" },
                              on: {
                                click: function($event) {
                                  _vm.editConfirmSelfPickupDialogVisible = false
                                }
                              }
                            },
                            [_vm._v("取 消")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "medium", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.toConfirmSelfPickupSubmit()
                                }
                              }
                            },
                            [_vm._v("确认自提")]
                          )
                        ],
                        1
                      )
                ])
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "结算确认书",
            visible: _vm.editBalanceConfirmationDialogVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.editBalanceConfirmationDialogVisible = $event
            }
          }
        },
        [
          _c("el-alert", {
            staticClass: "mar20-b",
            attrs: {
              title:
                "温馨提示：请特别注意仔细核对所填写的数据和信息内容，一旦点击确认，即签署合同，无法进行修改。",
              type: "error",
              effect: "dark",
              closable: false
            }
          }),
          _c(
            "el-form",
            {
              staticClass: "mar20-b",
              attrs: {
                "label-suffix": "：",
                "label-position": "left",
                size: "medium"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "mar20-b",
                  attrs: { label: "调价事由", prop: "region" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择调价事由", clearable: "" },
                      on: { change: _vm.thisModifyPriceChange },
                      model: {
                        value: _vm.thisModifyPriceType,
                        callback: function($$v) {
                          _vm.thisModifyPriceType = $$v
                        },
                        expression: "thisModifyPriceType"
                      }
                    },
                    _vm._l(_vm.modifyPriceType, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.text, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.thisModifyPriceType === "1001"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "因到货时间比合同原约定到货时间提前天数" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "w200 mar10-r",
                        attrs: {
                          type: "text",
                          oninput: "value = value.replace(/[^0-9.]/g, '')"
                        },
                        model: {
                          value: _vm.modifyPriceValue,
                          callback: function($$v) {
                            _vm.modifyPriceValue =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "modifyPriceValue"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.thisModifyPriceType === "1002"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "因到货时间比合同原约定到货时间延迟天数" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "w200 mar10-r",
                        attrs: {
                          type: "text",
                          oninput: "value = value.replace(/[^0-9.]/g, '')"
                        },
                        model: {
                          value: _vm.modifyPriceValue,
                          callback: function($$v) {
                            _vm.modifyPriceValue =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "modifyPriceValue"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.thisModifyPriceType === "1003"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "请输入原因" } },
                    [
                      _c("el-input", {
                        staticClass: "w300",
                        attrs: { type: "textarea", maxlength: "100" },
                        model: {
                          value: _vm.modifyPriceValue,
                          callback: function($$v) {
                            _vm.modifyPriceValue = $$v
                          },
                          expression: "modifyPriceValue"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._l(_vm.orderGoodsList, function(orderGoods) {
            return _c(
              "div",
              { key: orderGoods.goodsId },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "mar20-b",
                    attrs: {
                      "label-suffix": "：",
                      "label-position": "left",
                      size: "medium"
                    }
                  },
                  [
                    _c("el-form-item", { attrs: { prop: "goodsName" } }, [
                      _c("span", { staticClass: "mar5-r" }, [
                        _vm._v(" 商品名称： ")
                      ]),
                      _c("span", { staticClass: "mar40-r" }, [
                        _vm._v(" " + _vm._s(orderGoods.goodsName) + " ")
                      ]),
                      _c("span", { staticClass: "mar5-r" }, [
                        _vm._v(" 原单价： ")
                      ]),
                      _c("span", [_vm._v("¥ ")]),
                      _c("span", [
                        _vm._v(" " + _vm._s(orderGoods.sellFactPrice) + " ")
                      ])
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "数量",
                          prop: "finalSettlementQuantity"
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "mar10-r w100",
                          attrs: {
                            placeholder: "用户填写数量",
                            type: "text",
                            autocomplete: "off"
                          },
                          on: {
                            input: function($event) {
                              orderGoods.finalSettlementQuantity = _vm.formatNums(
                                orderGoods.finalSettlementQuantity,
                                true
                              )
                            },
                            change: _vm.editFinalSettlement
                          },
                          model: {
                            value: orderGoods.finalSettlementQuantity,
                            callback: function($$v) {
                              _vm.$set(
                                orderGoods,
                                "finalSettlementQuantity",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "orderGoods.finalSettlementQuantity"
                          }
                        }),
                        _c("span", { staticClass: "w110 mar5_r" }, [
                          _vm._v(" 最终确认结算价 ")
                        ]),
                        _c("el-input", {
                          staticClass: "mar10-r w100",
                          attrs: {
                            placeholder: "用户填写金额",
                            type: "text",
                            autocomplete: "off"
                          },
                          on: {
                            input: function($event) {
                              orderGoods.finalSettlementPrice = _vm.formatNums(
                                orderGoods.finalSettlementPrice,
                                true
                              )
                            },
                            change: _vm.editFinalSettlement
                          },
                          model: {
                            value: orderGoods.finalSettlementPrice,
                            callback: function($$v) {
                              _vm.$set(
                                orderGoods,
                                "finalSettlementPrice",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "orderGoods.finalSettlementPrice"
                          }
                        }),
                        _c("span", [
                          _vm._v(" " + _vm._s(orderGoods.goodsSpec) + " ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c("div", { staticClass: "text-right pad10-b f15 fb" }, [
            _c("span", [_vm._v("双方确认最终结算总金额： ")]),
            _c("span", [_vm._v("¥ ")]),
            _c("span", [_vm._v(" " + _vm._s(_vm.finalSettlementMoney) + " ")])
          ]),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function($event) {
                      _vm.editBalanceConfirmationDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "primary" },
                  on: { click: _vm.toSignMaterialSubmit }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "收货确认",
            visible: _vm.editReceiptConfirmationDialogVisible,
            width: "550px"
          },
          on: {
            "update:visible": function($event) {
              _vm.editReceiptConfirmationDialogVisible = $event
            }
          }
        },
        [
          _vm._l(_vm.refundGoodsList, function(orderGoods) {
            return _c(
              "div",
              {
                key: orderGoods.orderGoodsId,
                attrs: { id: "editReceiptConfirmation" }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      "label-suffix": "：",
                      "label-position": "left",
                      size: "medium",
                      "label-width": "155px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "mar5-b",
                        attrs: { label: "商品名称", prop: "goodsName" }
                      },
                      [
                        _c("span", [
                          _vm._v(" " + _vm._s(orderGoods.goodsName) + " ")
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "mar5-b",
                        attrs: { label: "购买数量", prop: "goodsQuantityAll" }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(orderGoods.goodsQuantityAll) +
                              " " +
                              _vm._s(orderGoods.goodsSpec.split("/")[1]) +
                              " "
                          )
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "mar5-b",
                        attrs: { label: "成交单价", prop: "sellFactPriceStr" }
                      },
                      [
                        _c("span", [_vm._v("¥ ")]),
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(orderGoods.goodsPaidInPrice) + " "
                          )
                        ])
                      ]
                    ),
                    orderGoods.isReceiptConfirmation === 1
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "mar5-b",
                            attrs: {
                              label: "请确认本次收货数量",
                              prop: "confirmReceiptGoodsQuantity"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "w300 mar10-r",
                              attrs: {
                                placeholder: "用户填写数量",
                                type: "number"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.updateQuantity(orderGoods)
                                }
                              },
                              model: {
                                value: orderGoods.confirmReceiptGoodsQuantity,
                                callback: function($$v) {
                                  _vm.$set(
                                    orderGoods,
                                    "confirmReceiptGoodsQuantity",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression:
                                  "orderGoods.confirmReceiptGoodsQuantity"
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(orderGoods.goodsSpec.split("/")[1]) +
                                  " "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "mar5-b",
                        attrs: {
                          label: "已退还货品数量",
                          prop: "goodsQuantityAccum"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(orderGoods.goodsQuantityAccum) + " "
                          )
                        ]),
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(orderGoods.goodsSpec.split("/")[1]) +
                              " "
                          )
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "mar5-b",
                        attrs: { label: "已退还金额", prop: "goodsMoneyAccum" }
                      },
                      [
                        _c("span", [_vm._v("¥ ")]),
                        _c("span", [
                          _vm._v(" " + _vm._s(orderGoods.goodsMoneyAccum) + " ")
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "bor-item fb mar5-b",
                        attrs: {
                          label: "本次返还小计",
                          prop: "confirmReceiptGoodsMoney"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "实付货款=订单实付金额-平台返点",
                                  placement: "top"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-info f15 gray_6"
                                })
                              ]
                            ),
                            _vm._v("\n            本次返还小计\n          ")
                          ],
                          1
                        ),
                        _c("span", [_vm._v("¥ ")]),
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                orderGoods.confirmReceiptGoodsMoney.toFixed(2)
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c("div", { staticClass: "text-right pad20-tb f15 fb" }, [
            _c("span", [_vm._v("本次预估返还合计： ")]),
            _c("span", [_vm._v("¥ ")]),
            _c("span", [
              _vm._v(" " + _vm._s(_vm.goodsMoneyAll.toFixed(2)) + " ")
            ])
          ]),
          _c("div", { staticClass: "text-right pad10-b f15 fb" }, [
            _c("span", [_vm._v("退款中金额： ")]),
            _c("span", [_vm._v("¥ ")]),
            _c("span", [_vm._v(" " + _vm._s(_vm.refundingMoney) + " ")])
          ]),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function($event) {
                      _vm.editReceiptConfirmationDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "medium",
                    type: "danger",
                    loading: _vm.isNotSave
                  },
                  on: { click: _vm.saveOrder }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改发货信息",
            visible: _vm.editDeliveryInfo,
            width: "900px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.editDeliveryInfo = $event
            }
          }
        },
        [
          _vm._l(_vm.orderDeliveryList, function(item) {
            return _c(
              "div",
              {
                key: item.logisticsId,
                staticStyle: { width: "900px", "margin-top": "10px" }
              },
              [
                item.deliveryType === "EXPRESS"
                  ? _c("div", [
                      _c("div", [_c("span", [_vm._v("发货方式：快递发货")])]),
                      _c("div", { staticClass: "mar10-t" }, [
                        _c(
                          "div",
                          { staticStyle: { width: "35%", float: "left" } },
                          [
                            _c("span", { staticClass: "w100" }, [
                              _vm._v("快递公司：")
                            ]),
                            _c(
                              "el-select",
                              {
                                staticClass: "w200",
                                on: {
                                  change: function($event) {
                                    return _vm.changeTelSelect()
                                  }
                                },
                                model: {
                                  value: item.logisticsCompanyCode,
                                  callback: function($$v) {
                                    _vm.$set(item, "logisticsCompanyCode", $$v)
                                  },
                                  expression: "item.logisticsCompanyCode"
                                }
                              },
                              _vm._l(_vm.logisticsCompanyList, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: item.description,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { width: "45%", float: "left" } },
                          [
                            _c("span", { staticClass: "w100" }, [
                              _vm._v("快递单号：")
                            ]),
                            _c("el-input", {
                              staticClass: "w300",
                              attrs: { maxlength: "50", "show-word-limit": "" },
                              model: {
                                value: item.logisticsNum,
                                callback: function($$v) {
                                  _vm.$set(item, "logisticsNum", $$v)
                                },
                                expression: "item.logisticsNum"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                item.deliveryType === "SHSM"
                  ? _c("div", [
                      _c("div", [_c("span", [_vm._v("发货方式：送货上门")])]),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-top": "10px", height: "40px" }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "50%", float: "left" } },
                            [
                              _c("span", { staticClass: "w100" }, [
                                _vm._v("送货人：")
                              ]),
                              _c("el-input", {
                                staticClass: "w200",
                                attrs: {
                                  maxlength: "20",
                                  "show-word-limit": ""
                                },
                                model: {
                                  value: item.logisticsCompanyName,
                                  callback: function($$v) {
                                    _vm.$set(item, "logisticsCompanyName", $$v)
                                  },
                                  expression: "item.logisticsCompanyName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { width: "50%", float: "left" } },
                            [
                              _c("span", { staticClass: "w100" }, [
                                _vm._v("车牌号：")
                              ]),
                              _c("el-input", {
                                staticClass: "w200",
                                attrs: {
                                  maxlength: "20",
                                  "show-word-limit": ""
                                },
                                model: {
                                  value: item.licensePlate,
                                  callback: function($$v) {
                                    _vm.$set(item, "licensePlate", $$v)
                                  },
                                  expression: "item.licensePlate"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-top": "10px", height: "40px" }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "50%", float: "left" } },
                            [
                              _c("span", { staticClass: "w40" }, [
                                _vm._v("联系电话：")
                              ]),
                              _c("el-input", {
                                staticClass: "w200",
                                attrs: {
                                  maxlength: "20",
                                  "show-word-limit": ""
                                },
                                model: {
                                  value: item.logisticInfo,
                                  callback: function($$v) {
                                    _vm.$set(item, "logisticInfo", $$v)
                                  },
                                  expression: "item.logisticInfo"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                item.deliveryType === "LOGISTICS"
                  ? _c("div", [
                      _c("div", [_c("span", [_vm._v("发货方式：物流发货")])]),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-top": "10px", height: "40px" }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "50%", float: "left" } },
                            [
                              _c("span", { staticClass: "w100" }, [
                                _vm._v("物流公司：")
                              ]),
                              _c("el-input", {
                                staticClass: "w200",
                                attrs: {
                                  maxlength: "20",
                                  "show-word-limit": ""
                                },
                                model: {
                                  value: item.logisticsCompanyName,
                                  callback: function($$v) {
                                    _vm.$set(item, "logisticsCompanyName", $$v)
                                  },
                                  expression: "item.logisticsCompanyName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { width: "50%", float: "left" } },
                            [
                              _c("span", { staticClass: "w100" }, [
                                _vm._v("物流单号：")
                              ]),
                              _c("el-input", {
                                staticClass: "w300",
                                attrs: {
                                  maxlength: "50",
                                  "show-word-limit": ""
                                },
                                model: {
                                  value: item.logisticsNum,
                                  callback: function($$v) {
                                    _vm.$set(item, "logisticsNum", $$v)
                                  },
                                  expression: "item.logisticsNum"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c("div", { staticStyle: { "margin-top": "10px" } }, [
                        _c(
                          "div",
                          { staticStyle: { width: "50%", float: "left" } },
                          [
                            _c("span", { staticClass: "w40" }, [
                              _vm._v("联系电话：")
                            ]),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "80px" },
                                on: { change: _vm.changeTelSelect },
                                model: {
                                  value: item.telType,
                                  callback: function($$v) {
                                    _vm.$set(item, "telType", $$v)
                                  },
                                  expression: "item.telType"
                                }
                              },
                              _vm._l(_vm.telTypeList, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              }),
                              1
                            ),
                            _c("el-input", {
                              staticStyle: {
                                width: "180px",
                                "margin-left": "5px"
                              },
                              attrs: { maxlength: "20", "show-word-limit": "" },
                              model: {
                                value: item.logisticInfo,
                                callback: function($$v) {
                                  _vm.$set(item, "logisticInfo", $$v)
                                },
                                expression: "item.logisticInfo"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            )
          }),
          _c(
            "div",
            { staticClass: "text-center mar10-t" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function($event) {
                      _vm.editDeliveryInfo = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: { click: _vm.exEditDeliveryInfo }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c("contractPreview", {
        attrs: {
          type: "sign",
          isAutoSignAuth: true,
          url: _vm.contractPreviewUrl,
          visible: _vm.contractPreviewVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.contractPreviewVisible = $event
          },
          confirm: _vm.contractPreviewConfirm
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.importCarVisible,
            title: "导入车辆",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.importCarVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "flex import-car-tips" }, [
            _c("i", {
              staticClass: "el-icon-warning-outline f18",
              staticStyle: { color: "#faae16" }
            }),
            _c("div", { staticClass: "mar2-t mar10-l" }, [
              _c("div", { staticClass: "f14 gray3 mar10-b" }, [
                _vm._v("导入须知！")
              ]),
              _c("div", { staticClass: "flex items-center" }, [
                _c("div", { staticClass: "gray9" }, [
                  _vm._v("下载导入模板，完善车辆信息。")
                ]),
                _c(
                  "a",
                  {
                    staticStyle: { color: "#1890ff" },
                    attrs: {
                      href:
                        "https://nfs.t.nxin.com/6869896999aa4ae698d6ec71643a89ce.xlsx",
                      target: "_blank"
                    }
                  },
                  [_vm._v("下载导入模板")]
                )
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "flex items-center mar20-t" },
            [
              _c("el-upload", {
                ref: "importCarUpload",
                attrs: {
                  action: _vm.env.VUE_APP_fileserver + "persistentUpload",
                  accept: ".xlsx,.xls",
                  "before-upload": _vm.importCarBeforeUpload,
                  "show-file-list": false,
                  "on-success": _vm.importCarSuccess
                },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function() {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-upload2"
                            }
                          },
                          [_vm._v("上传")]
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _c("div", { staticClass: "gray9 mar6-t mar10-l" }, [
                _vm._v("请上传Excel文件，大小在60M以内")
              ])
            ],
            1
          )
        ]
      ),
      _c("add-car-dialog", {
        staticClass: "add-card",
        attrs: { visible: _vm.addCarVisible },
        on: {
          "update:visible": function($event) {
            _vm.addCarVisible = $event
          },
          confirm: _vm.addCarConfirm
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }